import React, { useState } from 'react';
import RecordButton from '@/components/RecordButton';
import TextNoteDialog from '@/components/TextNoteDialog';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { PenLine } from 'lucide-react';

export default function DashboardPage() {
  const [showTextDialog, setShowTextDialog] = useState(false);

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-4 relative">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-2">
          MEMORANDUM
        </h1>
        <p className="text-muted-foreground text-lg">
          Registra, trascrivi e organizza automaticamente
        </p>
      </motion.div>

      <RecordButton />

      {/* Floating Action Button per note testuali - z-index più alto */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.3, duration: 0.4 }}
        className="fixed bottom-20 right-8 md:bottom-12 md:right-12 z-[100]"
      >
        <Button
          onClick={() => setShowTextDialog(true)}
          size="lg"
          className="h-14 w-14 md:h-16 md:w-16 rounded-full shadow-xl hover:shadow-2xl transition-all hover:scale-110 active:scale-95"
          data-testid="open-text-note-button"
          title="Scrivi nota testuale"
        >
          <PenLine className="w-6 h-6" />
        </Button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="mt-16 text-center max-w-md mb-20 md:mb-0"
      >
        <p className="text-sm text-muted-foreground">
          Le tue note verranno trascritte e inviate via email ogni ora
          in base alle categorie configurate.
        </p>
        <p className="text-xs text-muted-foreground mt-3 flex items-center justify-center gap-2">
          <PenLine className="w-4 h-4" />
          <span>Usa il pulsante in basso a destra per scrivere note testuali</span>
        </p>
      </motion.div>

      <TextNoteDialog
        open={showTextDialog}
        onClose={() => setShowTextDialog(false)}
      />
    </div>
  );
}